const washAndFoldHa = [
	{
		id: '2301',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 80,
		quantity: 1
	},
	{
		id: '2302',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Pillow Case',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 40,
		quantity: 1
	},

	{
		id: '2303',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Towel',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 50,
		quantity: 1
	},

	{
		id: '2304',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Quilt',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 350,
		quantity: 1
	},

	{
		id: '2305',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket (Single)',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 300,
		quantity: 1
	},

	{
		id: '2306',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket (Double)',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 380,
		quantity: 1
	},

	{
		id: '2307',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket Cover / Bed Cover',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 120,
		quantity: 1
	},

	{
		id: '2308',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Table Cover',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
	},

	{
		id: '2309',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Curtain (Per ft Width)',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 18,
		quantity: 1
	},

	{
		id: '2310',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sofa Cover',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
	},

	{
		id: '2311',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Chair / Cushion Cover',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
	},

	{
		id: '2312',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Cushion / Pillow',
		category: 'Household',
		service: 'Wash And Fold',
		price: 100,
		quantity: 1
	},

	{
		id: '2313',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Floor / Prayer Mat',
		category: 'Household',
		service: 'Wash And Fold',
		price: 55,
		quantity: 1
	},

	{
		id: '2314',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Doll (Big)',
		category: 'Household',
		service: 'Wash And Fold',
		price: 320,
		quantity: 1
	},

	{
		id: '2315',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Doll(Small)',
		category: 'Household',
		service: 'Wash And Fold',
		price: 200,
		quantity: 1
	},

	{
		id: '2316',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Car Seat Cover',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 100,
		quantity: 1
	},

	{
		id: '2317',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Accessories (Prayer Cap / Napkin)',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
	},

	{
		id: '2318',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Travel Bag',
		category: 'Household ',
		service: 'Wash And Fold',
		price: 280,
		quantity: 1
	}
];
export default washAndFoldHa;
